"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordingErrorMessage = exports.IndeterminateProgressOverlay = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_overlay_1 = require("@hopin-team/ui-overlay");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.IndeterminateProgressOverlay = (0, styled_components_1.default)(ui_overlay_1.Overlay).attrs({
  role: 'progressbar'
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n\n  &::before {\n    content: attr(aria-valuetext);\n    color: ", ";\n  }\n"], ["\n  display: flex;\n\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n\n  &::before {\n    content: attr(aria-valuetext);\n    color: ", ";\n  }\n"])), function (_a) {
  var rounded = _a.rounded;
  return rounded ? '0.75rem' : '0.75rem 0.75rem 0 0';
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
exports.RecordingErrorMessage = (0, styled_components_1.default)(ui_text_1.Text).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['rounded'].includes(prop);
  }
}).attrs({
  role: 'status',
  pattern: 'caption',
  element: 'p',
  color: 'grey-white',
  px: 2,
  py: 1
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background: ", ";\n  border-radius: 0;\n  box-shadow: 0 0.25rem 0.5rem -0.125rem rgba(0, 0, 0, 0.08);\n  border-radius: ", ";\n"], ["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background: ", ";\n  border-radius: 0;\n  box-shadow: 0 0.25rem 0.5rem -0.125rem rgba(0, 0, 0, 0.08);\n  border-radius: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ERROR', theme);
}, function (_a) {
  var rounded = _a.rounded;
  return rounded ? '0 0 0.5rem 0.5rem' : '0';
});
var templateObject_1, templateObject_2;